import React from 'react'

import { Flex, Icon, Text } from '@driftt/dds'
import { faHorizontalRule } from '@driftt/dds.icons/regular/faHorizontalRule'

interface AccountInfoItemProps {
  label: string
  validation: boolean
  property: string | React.ReactNode
  maxWidth?: number
}

const AccountInfoItem = ({ label, validation, property, maxWidth=300 }: AccountInfoItemProps) => {
  return (
    <Flex direction="column" gap={0} fullWidth>
      <Text variant="metadata">{label}</Text>
      {validation ? (
        <Text variant="body" truncate css={{ maxWidth: `${maxWidth}px` }}>
          {property}
        </Text>
      ) : (
        <Icon icon={faHorizontalRule} size="medium" />
      )}
    </Flex>
  )
}

export default AccountInfoItem
